<!-- 穿透主页 -->
<template>
    <div class='page_content'>
        <div class="btns">
            <el-button type="primary" plain size="mini" @click="clearData">全部清除</el-button>
            <el-button size="mini" type="primary" @click="closePage" style="margin:10px 0">隐藏</el-button>
        </div>
        <div class="bg-img">
            <img src="@/assets/img/home/chuansuomianban.png" alt="">
        </div>
        <div v-if="isTab">
            <el-tabs v-model="showTabs" @tab-click="selOrder" @tab-remove="delOrder" :stretch="false" :closable="true"
                class="el-tabs--border-card_new" type="card">
                <el-tab-pane v-for="item in tabData" :key="item.id" :label="item.titleName" :name="item.titleName">
                    <!-- <keep-alive> -->
                    <component v-if="pageLoaded" :is="currentComponent" :actionData="actionData"></component>
                    <!-- </keep-alive> -->
                </el-tab-pane>
            </el-tabs>
        </div>
        <!-- <printPlan ref="printPlan"></printPlan> -->
    </div>
</template>
<script>
import * as afterSales from '@/components/improveAfterSalesInformationList.js'
let componentAPI = require('./components.js');
export default {
    name: "penetrateHome",
    props: [],
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
        //这里存放数据
        return {
            actionData: [],
            currentComponent: '',
            tabData: [],
            isTab: false,
            showTabs: '',
            isPage: false,
            orderId: '',
            pageLoaded: true,
            printSource: '',
            printJurId: ''
        }
    },
    mounted() {
    },
    methods: {
        // 点击穿透字段 传参单号
        toDetail(orderId) {
            this.orderId = orderId
            this.getComponentData()
        },
        // 穿透组件主页关闭事件
        closePage() {
            this.isPage = false
            // 回调modular页面 显示页面和单据的状态
            this.$emit('setIsPenetrate', this.isPage);
        },
        // 清除缓存数据
        clearData() {
            this.$confirm('是否清除全部数据?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.closePage()
                componentAPI.default.unregisterAllComponents(); // 注销所有组件
                sessionStorage.removeItem("tabData");
                //component
                this.$message({
                    type: 'success',
                    message: '清除成功!'
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消'
                });
            });

        },
        // 获取当前单号对应的数据 公共方法
        openComponent() {
            this.orderId = sessionStorage.getItem('penetrateOrderId')
            this.getComponentData()
        },
        // 调用接口 给组件传参
        async getComponentData() {
            let orderInfo = {}
            try {
                orderInfo = JSON.parse(this.orderId)
            } catch (error) {
                orderInfo = this.orderId
            }
            if (orderInfo.type == 'querMoneysettlement') {
                sessionStorage.setItem(orderInfo.data.wmId, JSON.stringify(orderInfo))
                const data = orderInfo.data
                this.orderId = data.wmId
                // this.printSource = res.printSource
                this.printJurId = '1698307975197'
                // 触发组件openBox方法打开组件 传参 
                this.actionData = {
                    cate: 2, formData: afterSales,
                    oldData: data, orderId: this.orderId, printSouce: '',
                    printJurId: this.printJurId
                }
                this.currentComponent = 'improveAfterSalesInformationList'
                componentAPI.default.registerComponent(this.currentComponent)
                this.pageLoaded = true
                this.titleName = '出库申请信息'
                this.dataoper()
            } else {
                this.pageLoaded = false
                let responseData = await this.$http.getPenetrateData({ ids: [this.orderId] })
                console.log(responseData);
                if (responseData.status == 200) {
                    var res = responseData.result
                    if (res.dyform || res.component == 'informationSee' || res.component == 'settingJurisdictionApply1') {
                        this.printSource = res.printSource
                        this.printJurId = res.jurId
                        // 触发组件openBox方法打开组件 传参 
                        this.actionData = {
                            cate: 2, formData: res.dyform,
                            oldData: res.data, orderId: this.orderId, printSouce: this.printSource,
                            printJurId: this.printJurId
                        }
                        console.log(res.component,'res.component111');
                        this.currentComponent = res.component
                        componentAPI.default.registerComponent(this.currentComponent)
                        this.pageLoaded = true
                        this.titleName = res.titleName
                        this.dataoper()
                    } else {
                        this.$emit("closeClick", responseData.message == null || responseData.message.indexOf('操作成功') == 1 ? '暂无跳转数据' : responseData.message)
                    }
                } else {
                    this.$emit("closeClick", responseData.message == null ? '暂无跳转数据' : responseData.message)
                }
            }

        },
        // 数据操作业务逻辑
        dataoper() {
            var titleName = this.titleName + ':' + this.orderId
            // 构建单个tab对象
            let tabParam = {
                id: this.orderId, //单据Id
                component: this.currentComponent, //组件名
                titleName: titleName //标题名称
            }
            // 从缓存获取tabData
            var data = sessionStorage.getItem('tabData')
            // 判断data是否为空
            if (!data || data == '[]' || data == 'null' || data == 'undefined') {
                // 如果为空 unshfit进去新的对象
                this.tabData.unshift(tabParam)
                // tabNAme默认显示第一个名字
                this.showTabs = this.tabData[0].titleName
            } else {
                // 定义变量 用于判断缓存是否有相同的单子
                var flag = true
                // 如果缓存不为空
                this.tabData = JSON.parse(sessionStorage.getItem('tabData'))
                // 循环对比判断是否存在相同的单子
                for (let index = 0; index < this.tabData.length; index++) {
                    if (this.tabData[index].id == this.orderId) {
                        this.showTabs = this.tabData[index].titleName
                        this.orderId = this.tabData[index].id
                        this.getData()
                        flag = false
                        break
                    }
                }
                if (flag) {
                    this.tabData.unshift(tabParam)
                    this.showTabs = this.tabData[0].titleName
                }
            }
            sessionStorage.setItem("businessid", this.showTabs.split(":")[1])
            sessionStorage.setItem(
                "tabData", JSON.stringify(this.tabData)
            );
            if (this.tabData.length > 0) this.isTab = true
        },
        // 编辑单据
        selOrder(e) {
            this.orderId = e.name.split(':')[1]
            sessionStorage.setItem("businessid", this.showTabs.split(":")[1])
            this.resetSetItem('penetrateOrderId', this.orderId);
            this.getData()
        },
        async getData() {
            const info = sessionStorage.getItem(this.orderId) || ''
            if (info) {
                const data = JSON.parse(sessionStorage.getItem(this.orderId)).data
                this.orderId = data.wmId
                // this.printSource = res.printSource
                this.printJurId = '1698307975197'
                // 触发组件openBox方法打开组件 传参 
                this.actionData = {
                    cate: 2, formData: afterSales,
                    oldData: data, orderId: this.orderId, printSouce: '',
                    printJurId: this.printJurId
                }
                this.currentComponent = 'improveAfterSalesInformationList'
                componentAPI.default.registerComponent(this.currentComponent)
                this.pageLoaded = true
                this.titleName = '出库申请信息'
                this.dataoper()
            } else {

                this.pageLoaded = false
                let responseData = await this.$http.getPenetrateData({ ids: [this.orderId] })
                if (responseData.status == 200) {
                    var res = responseData.result
                    if (JSON.stringify(res) == '{}') {
                        this.isPage = false
                        this.$message.error("暂无跳转数据")
                        // 回调modular页面 显示页面和单据的状态
                        this.$emit('setIsPenetrate', this.isPage);
                        return
                    }
                    console.log(res);
                    this.printJurId = res.jurId
                    // 触发组件openBox方法打开组件 传参 
                    this.currentComponent = res.component
                    componentAPI.default.registerComponent(this.currentComponent)
                    this.printSource = res.printSource
                    this.actionData = {
                        cate: 2, formData: res.dyform,
                        oldData: res.data, orderId: this.orderId, printSouce: this.printSource,
                        printJurId: this.printJurId
                    }
                    this.pageLoaded = true
                } else {
                    this.$message({
                        message: responseData.message,
                        type: 'error'
                    });
                }
            }
        },
        //删除单据
        delOrder(targetName) {
            var strArr = []
            var activeOrderId = targetName.split(':')[1]
            this.tabData.forEach((item, i) => {
                if (item.id == activeOrderId) {
                    if (i == 0) {
                        if (this.tabData.length > 1) {
                            this.showTabs = this.tabData[i + 1].titleName
                            this.orderId = this.tabData[i + 1].id
                            strArr = this.tabData.splice(i, 1)
                        } else {
                            strArr = this.tabData.splice(i, 1)
                            this.closePage()
                        }
                    } else {
                        this.showTabs = this.tabData[i - 1].titleName
                        this.orderId = this.tabData[i - 1].id
                        strArr = this.tabData.splice(i, 1)
                    }
                    componentAPI.default.unregisterComponent(strArr[0].component)
                    this.getData()
                }
            })
            sessionStorage.setItem(
                "tabData", JSON.stringify(this.tabData)
            );
        },
        // 穿透组件打印方法
        showPrintPlan() {
            // 调用全局方法 判断Websocket是否连接
            if (this.$printSocketApi.printExeMsg() != false) {
                // 选中的数据
                this.$refs.printPlan.openDia(this.orderId, this.printSource, this.printJurId)
            } else {
                return
            }
        },
    },
    created() {
        this.openComponent()
    }
}
</script>
<style scoped>
.v-modal {
    position: static !important;
    width: 100%;
    height: 100%;
    background: transparent;
}

.bg-img {
    /* transform:rotate(180deg); */
    background-image: url("../assets/img/home/bg1.png");
    background-size: 100%;
    width: 140px;
    height: 50px;
    position: absolute;
    left: 50%;
    top: 0;
    transform: translate(-50%, 0);
    margin-top: -3px;
}

.bg-img img {
    margin-top: 12px;
    margin-left: 12px;
    width: 83%;
}

.btns {
    display: flex;
    justify-content: flex-end;
    width: 100%;
}

.btns button {
    margin: 10px 10px 10px 0 !important;
}
</style>